/* template */
<template><div :style="[(warpStyle)] | transRpxStyle" class="warp"><template v-if="(!error)"><mpx-text :style="[(ruleStyle)] | transRpxStyle" @tap="gotoLink(pageConfig.rule.link)" class="rule">规则</mpx-text><red-packet-open :template="(info.template)" :btnText="(btnText)" :couponInfo="(activityCouponList || [])" :couponList="(couponList)" @couponClick="couponPopShow" @click="toUseCoupon" @goToLink="couponToUse" v-if="(hasGetCoupon && hasCoupon && couponList)"/><red-packet-close :couponInfo="(activityCouponList || [])" :config="(pageConfig.redPacket)" :template="(info.template)" :btnText="(btnText)" @click="getCouponCz" v-else-if="(activityCouponList || pageConfig)"/><scroll-text :text="(textRoll)" v-if="(textRoll)"/><cz-banner :template="(info.template)" :params="(pageConfig.conversion)" v-if="(pageConfig.conversion.isShow)"/><gas-station-list :showTabOrder="(pageConfig.showTabOrder || 'gasFirst')" :params="(stationParams)" @stationShow="stationShow" @changeTab="changeTab" @footerBtnClick="toMoreStation" @toGuide="dhNearby" @goCarWahDetail="goCarWahDetail" class="container-station" v-if="(stationParams && showGasModule)"/><image-list :imageList="(pageConfig.imageList)"/><res-banner :template="(info.template)" v-if="(activityCouponList)"/></template><error-view :message="(errmsg)" v-else/><popup-result :template="(info.template)" :popupData="(popupResult)" :pageConfig="(pageConfig)" @close="popupClose" @click="popupClick" v-if="(popupResult)"/></div></template>

/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"m4c8f8f48"}'>
.mpx-button
    padding 0
    &::after
      display none
</style>
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m4c8f8f48"}'>
  @font-face {
    font-family: DIN-Bold-self;
    src: url(https://dpubstatic.udache.com/static/dpubimg/5e78fa44-928b-4132-aa31-d5bac7b67ece.ttf);
  }
  .warp
    min-height 100vh
    padding-bottom 180rpx
    font-size: 0;
    overflow hidden
    box-sizing: border-box;
    line-height: normal;
    background-size: 100% auto
    background-repeat: no-repeat;
    .rule
      position absolute
      right 0
      border-radius: 100rpx 0 0 100rpx;
      font-family: PingFangSC-Semibold;
      font-size: 24rpx;
      letter-spacing: 1rpx;
      font-weight: bold
      padding 4rpx 16rpx 4rpx 25rpx
    .header-image
      width: 750rpx
    .container-station
      margin 40rpx 25rpx 0
      display: block
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m4c8f8f48"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex4c8f8f48%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./index.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Findex4c8f8f48%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m4c8f8f48"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index4c8f8f48/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'error-view':()=>import(/* webpackChunkName: "error-view" */"../../components/common/error-view.mpx?async=error-view&isComponent&outputPath=components%2Ferror-view6fe98fb7%2Findex").then(res => getComponent(res)),'image-list':getComponent(require("../../components/common/image-list.mpx?isComponent&outputPath=components%2Fimage-list73d9d186%2Findex")),'res-banner':getComponent(require("../../components/common/res-banner.mpx?isComponent&outputPath=components%2Fres-banner12bfcde6%2Findex")),'scroll-text':getComponent(require("../../components/common/scroll-text.mpx?isComponent&outputPath=components%2Fscroll-text109be98e%2Findex")),'red-packet-close':getComponent(require("../../components/cz/red-packet-close.mpx?isComponent&outputPath=components%2Fred-packet-close329ca790%2Findex")),'red-packet-open':getComponent(require("../../components/cz/red-packet-open-cz.mpx?isComponent&outputPath=components%2Fred-packet-open-cz7eec299c%2Findex")),'popup-result':getComponent(require("../../components/cz/popup-result.mpx?isComponent&outputPath=components%2Fpopup-resultf7923582%2Findex")),'cz-banner':getComponent(require("../../components/cz/cz-banner.mpx?isComponent&outputPath=components%2Fcz-banner3d0079a2%2Findex")),'gas-station-list':getComponent(require("../../../node_modules/@didi/ut-components/packages/gas-station-list/components/index.mpx?isComponent&outputPath=components%2Findex54230687%2Findex")),'mpx-text':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-text.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
